import api, { getData, getIncluded } from '@/axiosConfig'
import { isEqual } from 'lodash'
import moment from 'moment'
import {
  deconstructOrder,
  deconstructItem,
  deconstructRecipient,
  deconstructSender,
  deconstructOrderDetail,
  findIncluded,
  findIncludedItems
} from '@/state/deconstructionFunctions'
import {
  compare,
  status,
  orderStates,
  isCard,
  buildCartFromBag
} from '../../helpers'

const gemnoteAPI = api()
import router from '@/router'
import i18n from '../../internatinalization/i18n'
import requestErrorHandler from '@/utils/request-error-handler'

import {
  SET_TOTAL_ORDER_RECORDS,
  LOAD_ORDERS_LIST,
  LOAD_ORDER_DETAIL,
  SET_ORDERS_LIST,
  SET_ORDER_DETAIL,
  SET_SELECTED_RECIPIENT,
  ADD_PRODUCT_TO_SHOPPING_BAG,
  REMOVE_PRODUCT_FROM_SHOPPING_BAG,
  INCREASE_ITEM_SHOPPING_BAG,
  DECREASE_ITEM_SHOPPING_BAG,
  SET_CARD_MESSAGE,
  SET_ORDER_ID,
  CLEAR_ORDER,
  RESET_ORDER_STATE,
  DISABLE_PAY_BUTTON,
  SET_SELECTED_TEMPLATE,
  SET_SALESFORCE_RESOURCE_TYPE,
  SET_SALESFORCE_RECORD_UID,
  IS_CREATING_ORDER,
  SET_ALL_TEAM_ORDERS,
  SET_CHECK_INVENTORY_RESPONSE,
  SET_SHIPPING_RATES,
  SET_LOADING_SHIPPING_RATES,
  SET_SELECTED_SHIPPING_RATE,
  SET_SHIPPING_RATE_ERROR,
  SET_ORDER,
  UPDATE_ITEM_QTY_SHOPPING_BAG
  // SET_TEAM_AVAILABLE_ORDERS,
  // SET_REMAINING_SHIPMENTS, UPDATE_ITEM_QTY_SHOPPING_BAG
} from '@/state/mutationTypes'

export default {
  async setAdditionalOrderLimit({ commit, dispatch }, limit) {
    try {
      const formData = new FormData()
      formData.append('paige_additional_order_limit[order_limit]', limit)
      const {
        data: {
          data: {
            attributes: { availableOrders }
          }
        }
      } = await gemnoteAPI({
        method: 'POST',
        url: 'team/additional_order_limits',
        data: formData,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      })
      const {
        data: { remaining_orders: remainingOrders }
      } = await gemnoteAPI.get('team/dashboard_metrics/remaining_orders')
      commit('team/SET_TEAM_AVAILABLE_ORDERS', availableOrders, { root: true })
      commit('report/SET_REMAINING_SHIPMENTS', remainingOrders, {
        root: true
      })
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [`You have ${limit} additional sends.`]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { message } = error.response.data.errors[0]
          dispatch(
            'notification/pushNotification',
            { type: 'error', messages: [message] },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('order.action.get-my-orders-error')]
          },
          { root: true }
        )
      }
    }
  },
  async createOrder(
    { commit, state, dispatch, rootGetters },
    { recipientId, salesforceResourceType = null, salesforceResourceUID = null }
  ) {
    try {
      let shoppingBagProducts = state.shoppingBagProducts
      const isSalesForceConnected =
        rootGetters['integration/isSalesForceConnected']
      const isEditing =
        parseInt(router.history.current.query.editing || '') === 1
      let route = isSalesForceConnected
        ? 'LinkSalesForceRecord'
        : 'ConfirmOrder'

      if (salesforceResourceUID && salesforceResourceType) {
        route = 'ConfirmOrder'
      }
      let orderId = null
      if (!state.currentOrderId) {
        commit(IS_CREATING_ORDER, true)
        let orderObject = {
          order: {
            recipient_id: state.selectedRecipientId,
            card_message: state.cardMessage,
            salesforce_resource_type: state.salesforceResourceType || null,
            salesforce_resource_uid: state.salesforceResourceUID || null,
            selected_items_json: shoppingBagProducts.filter(
              ({ type }) => type === 'bundle'
            )
          }
        }
        let response = await gemnoteAPI.post(`team/orders`, orderObject)
        if (response.data.data.type !== 'orders') {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [i18n.t('order.action.no-order-id')]
            },
            { root: true }
          )
          commit(IS_CREATING_ORDER, false)
          return
        }
        orderId = response.data.data.id
        commit(SET_ORDER_ID, orderId)
        commit(SET_ORDER, response.data.data)
      } else {
        orderId = state.currentOrderId
        commit(IS_CREATING_ORDER, true)
        let orderObject = {
          order: {
            recipient_id: recipientId,
            card_message: state.cardMessage,
            salesforce_resource_type: salesforceResourceType,
            salesforce_resource_uid: salesforceResourceUID,
            selected_items_json: shoppingBagProducts.filter(
              ({ type }) => type === 'bundle'
            )
          }
        }
        let response = await gemnoteAPI.put(
          `team/orders/${orderId}`,
          orderObject
        )
        commit(SET_ORDER, response.data.data)
      }

      let errors = []
      const cartItems = buildCartFromBag(shoppingBagProducts)

      const requestPromises = cartItems.map(item => {
        return new Promise(async (resolve, reject) => {
          try {
            let requestData = {
              item: {
                product_variant_id: item.product_variant_id,
                quantity: item.quantity,
                bundle_id: item.bundle_id
              }
            }
            let response = await gemnoteAPI.post(
              `team/orders/${orderId}/items`,
              requestData
            )
            return resolve({
              success: true,
              message: i18n.t('order.action.added-to-order-success', {
                0: item.product_variant_id,
                1: orderId
              })
            })
          } catch (error) {
            console.log(error)
            if (error.response) {
              errors.push(
                i18n.t('order.action.added-to-order-error', {
                  0: item.product_variant_id
                })
              )
              errors.push(error.response.data.errors[0].message[0])
              return reject(errors)
            } else {
              errors.push(i18n.t('order.action.exception-order-creation'))
              return reject(errors)
            }
          }
        })
      })

      Promise.all(requestPromises)
        .then(() => {
          commit(IS_CREATING_ORDER, false)
          if (isEditing) {
            router.push({ name: 'ConfirmOrder' })
          } else {
            router.push({ name: route })
          }
        })
        .catch(errors => {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
          commit(IS_CREATING_ORDER, false)
        })

      const selectedShippingRate = state.selectedShippingRate
      if (
        selectedShippingRate &&
        selectedShippingRate.id &&
        !state.shippingRateErrorOccur
      ) {
        await dispatch('addRateToOrder', {
          orderId: orderId,
          rateId: selectedShippingRate.id
        })
      }
    } catch (error) {
      requestErrorHandler(
        error,
        i18n.t('order.action.exception-order-creation')
      )
      console.log(error)
      commit(IS_CREATING_ORDER, false)
    }
  },
  async createMultipleOrder({ commit, state, dispatch }, id) {
    try {
      commit(IS_CREATING_ORDER, true)
      commit(DISABLE_PAY_BUTTON, true)
      let shoppingBagProducts = state.shoppingBagProducts
      const data = []
      shoppingBagProducts.forEach(product => {
        if (product.type && product.type === 'bundle') {
          product.items.forEach(item => {
            if (!data.includes(item.id)) {
              data.push({
                product_variant_id: parseInt(item.id),
                quantity: parseInt(product.quantity * item.quantity),
                bundle_id: parseInt(product.bundle_id)
              })
            }
          })
        } else {
          if (!data.includes(product.selectedVariant.id)) {
            data.push({
              product_variant_id: parseInt(product.selectedVariant.id),
              quantity: parseInt(product.quantity)
            })
          }
        }
      })

      const response = await gemnoteAPI.post(`team/orders/recipient_list`, {
        paige_recipient_list_order: {
          bulk_import_id: id,
          recipient_list_order_items: data,
          note: '',
          card_message: state.cardMessage,
          salesforce_resource_type: state.salesforceResourceType,
          salesforce_resource_uid: state.salesforceResourceUID
        }
      })

      if (response.status === 200) {
        commit(CLEAR_ORDER)
        dispatch('recipient/resetRecipientState', {}, { root: true })
        await dispatch(
          'profile/getProfile',
          { reloadProfile: false },
          { root: true }
        )

        // push to Confirmed Order page
        router.push({
          path: '/confirmed-order',
          query: { isConfirmed: true }
        })
      }

      commit(IS_CREATING_ORDER, false)
      commit(DISABLE_PAY_BUTTON, false)
    } catch (error) {
      console.log(error)
      commit(IS_CREATING_ORDER, false)
      commit(DISABLE_PAY_BUTTON, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('order.action.exception-order-creation'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async checkStoreInventory({ commit, dispatch, state }, id) {
    try {
      commit(IS_CREATING_ORDER, true)
      let { shoppingBagProducts } = state
      let orderItems = []

      shoppingBagProducts.forEach(product => {
        if (product.type && product.type === 'bundle') {
          product.items.forEach(item => {
            if (!orderItems.includes(item.id)) {
              orderItems.push({
                product_variant_id: parseInt(item.id),
                quantity: parseInt(product.quantity * item.quantity),
                bundle_id: parseInt(product.bundle_id)
              })
            }
          })
        } else {
          if (!orderItems.includes(product.selectedVariant.id)) {
            orderItems.push({
              product_variant_id: parseInt(product.selectedVariant.id),
              quantity: parseInt(product.quantity)
            })
          }
        }
      })

      const response = await gemnoteAPI.post(
        `/team/orders/recipient_list/${id}/check_inventory`,
        {
          paige_recipient_list_order: {
            bulk_import_id: id,
            recipient_list_order_items: orderItems,
            note: '',
            card_message: state.cardMessage,
            salesforce_resource_type: state.salesforceResourceType,
            salesforce_resource_uid: state.salesforceResourceUID
          }
        }
      )

      const data = response.data || []

      if (response.status === 200 && data.length) {
        const mappedData = data.map(item => {
          if (item.bundle_id) {
            return item.product
          } else {
            return item
          }
        })
        commit(SET_CHECK_INVENTORY_RESPONSE, mappedData)
        return commit(IS_CREATING_ORDER, false)
      }

      commit(IS_CREATING_ORDER, false)
      const isEditing =
        parseInt(router.history.current.query.editing || '') === 1
      router.push({
        name: isEditing ? 'ConfirmOrder' : 'CardMessage'
      })
    } catch (error) {
      commit(IS_CREATING_ORDER, false)
      console.log(error)
      dispatch(
        'notification/pushNotification',
        {
          type: 'error',
          messages: [i18n.t('server.server-error')]
        },
        { root: true }
      )
    }
  },
  async cancelOrder({ dispatch }, payload) {
    try {
      await gemnoteAPI.post(`/team/orders/${payload.orderId}/cancel`)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [`Order #${payload.internalOrderId} has been canceled.`]
        },
        { root: true }
      )
      await dispatch('getIndividualOrder', payload.orderId)
    } catch (error) {
      dispatch(
        'notification/pushNotification',
        {
          type: 'error',
          messages: [i18n.t('server.server-error')]
        },
        { root: true }
      )
    }
  },
  async getAllOrders({ commit, rootGetters, rootState }) {
    try {
      commit(SET_ALL_TEAM_ORDERS, [])

      let isTeamOwner = rootGetters['profile/isTeamOwner']
      let apiRoute = ''

      isTeamOwner
        ? (apiRoute = `team/orders?filters[user_id]=${rootState.profile.user.id}`)
        : (apiRoute = `team/users/${rootState.profile.user.id}`)

      const response = await gemnoteAPI.get(apiRoute)
      let { data = [] } = response.data
      let { included = [] } = response.data
      let orderItemsIncluded = included.filter(
        resource => resource.type === 'orderItems'
      )

      let orders = data
        .filter(order => order.attributes.state !== orderStates.UNPAID)
        .map(order => {
          return {
            id: order.id,
            ...order.attributes,
            orderItems: [...order.relationships.items.data]
          }
        })

      for (let index = 0; index < orders.length; index++) {
        const order = orders[index]
        let foundItems = orderItemsIncluded.filter(
          items => items.relationships.order.data.id == order.id
        )

        if (foundItems.length) {
          let items = foundItems.map(item => {
            return {
              ...item.attributes
            }
          })

          order.orderItems = [...items]
        } else {
          order.orderItems = []
        }
      }

      commit(SET_ALL_TEAM_ORDERS, orders)
    } catch (error) {
      console.log(error)
    }
  },
  async getMyOrdersList(
    { commit, dispatch, rootState, rootGetters },
    { page = 1, perPage = 50, nameOrEmail = '' }
  ) {
    try {
      commit(LOAD_ORDERS_LIST, status.LOADING)
      commit(SET_ALL_TEAM_ORDERS, [])
      let isTeamOwner = rootGetters['profile/isTeamOwner']
      let apiRoute = ''

      if (isTeamOwner) {
        apiRoute =
          nameOrEmail.length > 0
            ? `team/orders?page[number]=${page}&page[size]=${perPage}&filters[user_id]=${rootState.profile.user.id}&filters[name_or_email]=${nameOrEmail}`
            : `team/orders?page[number]=${page}&page[size]=${perPage}&filters[user_id]=${rootState.profile.user.id}`
      } else {
        apiRoute = `team/users/${rootState.profile.user.id}/orders?page[number]=${page}&page[size]=${perPage}`
      }

      let response
      let resultingOrders
      response = await gemnoteAPI.get(apiRoute)
      let { data = [] } = response.data
      let { included = [] } = response.data
      let { totalCount } = response.data.meta
      commit(SET_TOTAL_ORDER_RECORDS, totalCount)

      resultingOrders = data
        .filter(order => order.attributes.state !== orderStates.UNPAID)
        .map(order => {
          const deconstructedOrder = deconstructOrder(order)
          const recipient = findIncluded(
            included,
            'recipients',
            deconstructedOrder.recipientId
          )

          const sender = findIncluded(
            included,
            'users',
            deconstructedOrder.userId
          )

          return {
            ...deconstructedOrder,
            recipient: {
              ...deconstructRecipient(recipient)
            },
            sender: {
              ...sender
            }
          }
        })
      commit(SET_ORDERS_LIST, resultingOrders.sort(compare))
      commit(LOAD_ORDERS_LIST, status.LOADED)
      dispatch('getAllOrders')
    } catch (error) {
      console.log(error)
      commit(LOAD_ORDERS_LIST, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { message } = error.response.data.errors[0]
          dispatch(
            'notification/pushNotification',
            { type: 'error', messages: [message] },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('order.action.get-my-orders-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getAllTeamOrders({ commit }) {
    try {
      commit(SET_ALL_TEAM_ORDERS, [])
      let apiRoute = `team/orders`
      const response = await gemnoteAPI.get(apiRoute)
      let { data = [] } = response.data
      let { included = [] } = response.data
      let orderItemsIncluded = included.filter(
        resource => resource.type === 'orderItems'
      )

      let orders = data
        .filter(order => order.attributes.state !== orderStates.UNPAID)
        .map(order => {
          return {
            id: order.id,
            ...order.attributes,
            orderItems: [...order.relationships.items.data]
          }
        })

      for (let index = 0; index < orders.length; index++) {
        const order = orders[index]
        let foundItems = orderItemsIncluded.filter(
          items => items.relationships.order.data.id == order.id
        )

        if (foundItems.length) {
          let items = foundItems.map(item => {
            return {
              ...item.attributes
            }
          })

          order.orderItems = [...items]
        } else {
          order.orderItems = []
        }
      }

      commit(SET_ALL_TEAM_ORDERS, orders)
    } catch (error) {
      console.log(error)
    }
  },
  async getTeamOrdersList(
    { commit, dispatch },
    { page = 1, perPage = 50, nameOrEmail = '' }
  ) {
    try {
      commit(SET_ALL_TEAM_ORDERS, [])
      commit(LOAD_ORDERS_LIST, status.LOADING)
      let apiRoute =
        nameOrEmail.length > 0
          ? `team/orders?page[number]=${page}&page[size]=${perPage}&filters[name_or_email]=${nameOrEmail}`
          : `team/orders?page[number]=${page}&page[size]=${perPage}`
      let response = await gemnoteAPI.get(apiRoute)
      let resultingOrders

      let { data = [] } = response.data
      let { included = [] } = response.data
      let { totalCount } = response.data.meta
      commit(SET_TOTAL_ORDER_RECORDS, totalCount)

      resultingOrders = data
        .filter(order => order.attributes.state !== orderStates.UNPAID)
        .map(order => {
          const deconstructedOrder = deconstructOrder(order)

          const recipient = findIncluded(
            included,
            'recipients',
            deconstructedOrder.recipientId
          )

          const sender = findIncluded(
            included,
            'users',
            deconstructedOrder.userId
          )

          return {
            ...deconstructedOrder,
            recipient: {
              ...deconstructRecipient(recipient)
            },
            sender: {
              ...sender
            }
          }
        })

      commit(SET_ORDERS_LIST, resultingOrders.sort(compare))
      commit(LOAD_ORDERS_LIST, status.LOADED)
      dispatch('getAllTeamOrders')
    } catch (error) {
      console.log(error)
      commit(LOAD_ORDERS_LIST, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { message } = error.response.data.errors[0]
          dispatch(
            'notification/pushNotification',
            { type: 'error', messages: [message] },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('order.action.get-team-orders-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getAllRedemptionOrders({ commit }) {
    try {
      commit(SET_ALL_TEAM_ORDERS, [])
      let apiRoute = `team/orders?filters[redemption]=true`
      const response = await gemnoteAPI.get(apiRoute)
      let { data = [] } = response.data
      let { included = [] } = response.data
      let orderItemsIncluded = included.filter(
        resource => resource.type === 'orderItems'
      )

      let orders = data
        .filter(order => order.attributes.state !== orderStates.UNPAID)
        .map(order => {
          return {
            id: order.id,
            ...order.attributes,
            orderItems: [...order.relationships.items.data]
          }
        })

      for (let index = 0; index < orders.length; index++) {
        const order = orders[index]
        let foundItems = orderItemsIncluded.filter(
          items => items.relationships.order.data.id == order.id
        )

        if (foundItems.length) {
          let items = foundItems.map(item => {
            return {
              ...item.attributes
            }
          })

          order.orderItems = [...items]
        } else {
          order.orderItems = []
        }
      }

      commit(SET_ALL_TEAM_ORDERS, orders)
    } catch (error) {
      console.log(error)
    }
  },
  async getRedemptionOrdersList(
    { commit, dispatch },
    { page = 1, perPage = 50, nameOrEmail = '' }
  ) {
    try {
      commit(LOAD_ORDERS_LIST, status.LOADING)
      commit(SET_ALL_TEAM_ORDERS, [])
      let resultingOrders
      let apiRoute =
        nameOrEmail.length > 0
          ? `team/orders?page[number]=${page}&page[size]=${perPage}&filters[redemption]=true&filters[name_or_email]=${nameOrEmail}`
          : `team/orders?page[number]=${page}&page[size]=${perPage}&filters[redemption]=true`
      let response = await gemnoteAPI.get(apiRoute)
      let { data } = response.data
      let { included = [] } = response.data
      let { totalCount } = response.data.meta
      commit(SET_TOTAL_ORDER_RECORDS, totalCount)
      resultingOrders = data
        .filter(order => order.attributes.state !== orderStates.UNPAID)
        .map(order => {
          const deconstructedOrder = deconstructOrder(order)
          const recipient = findIncluded(
            included,
            'recipients',
            deconstructedOrder.recipientId
          )

          const sender = findIncluded(
            included,
            'users',
            deconstructedOrder.userId
          )

          return {
            ...deconstructedOrder,
            recipient: {
              ...deconstructRecipient(recipient)
            },
            sender: {
              ...sender
            }
          }
        })
      commit(SET_ORDERS_LIST, resultingOrders.sort(compare))
      commit(LOAD_ORDERS_LIST, status.LOADED)
      dispatch('getAllRedemptionOrders')
    } catch (error) {
      console.log(error)
      commit(LOAD_ORDERS_LIST, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { message } = error.response.data.errors[0]
          dispatch(
            'notification/pushNotification',
            { type: 'error', messages: [message] },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('order.action.get-redemption-orders-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getIndividualOrder({ commit, dispatch }, orderId) {
    try {
      commit(LOAD_ORDER_DETAIL, status.LOADING)
      const response = await gemnoteAPI.get(`team/orders/${orderId}`)

      const [order, included] = [getData(response), getIncluded(response)]
      const deconstructedOrder = deconstructOrderDetail(order)
      const recipient = findIncluded(
        included,
        'recipients',
        deconstructedOrder.recipientId
      )
      const sender = findIncluded(included, 'users', deconstructedOrder.userId)
      const items = findIncludedItems(included).map(deconstructItem)

      let resultingOrder = {
        items,
        ...deconstructedOrder,
        recipient: recipient,
        sender: deconstructSender(sender)
      }
      commit(SET_ORDER_DETAIL, resultingOrder)
      commit(SET_ORDER, response.data.data)
      commit(LOAD_ORDER_DETAIL, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(SET_ORDER_DETAIL, {})
      commit(LOAD_ORDER_DETAIL, status.LOADED)
      if (error.response) {
        if (error.response.status === 500) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [i18n.t('server.server-error')]
            },
            { root: true }
          )
          commit(SET_ORDER_DETAIL, {})
        } else if (error.response.status === 404) {
          router.push({ path: '/404' })
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('order.action.order-detail-error')]
          },
          { root: true }
        )
      }
    }
  },
  async addProductToShoppingBag({ commit, dispatch, state }, productObject) {
    let route = { router }

    try {
      let actualProducts = state.shoppingBagProducts
      if (actualProducts) {
        let foundProduct = actualProducts.find(
          product =>
            product.type == 'product' &&
            product.selectedVariant.id === productObject.selectedVariant.id
        )
        if (!foundProduct) {
          actualProducts.push(productObject)
          commit(ADD_PRODUCT_TO_SHOPPING_BAG, actualProducts)

          let name = ''
          route.router.currentRoute.path.includes('card-message')
            ? (name = 'AddRecipient')
            : (name = 'ShoppingBag')

          router.push({ name })
        } else {
          if (
            foundProduct.selectedVariant.id === productObject.selectedVariant.id
          ) {
            foundProduct.quantity += productObject.quantity

            if (
              foundProduct.quantity >
              productObject.selectedVariant.inventoriesCount
            ) {
              foundProduct.quantity -= productObject.quantity
              dispatch(
                'notification/pushNotification',
                {
                  type: 'error',
                  messages: [
                    i18n.t('order.action.max-items-cart', {
                      0: foundProduct.quantity
                    })
                  ]
                },
                { root: true }
              )
              return
            }

            let newProducts = actualProducts.filter(
              product =>
                product.type == 'product' &&
                product.selectedVariant.id !== productObject.selectedVariant.id
            )
            newProducts.push(foundProduct)
            commit(ADD_PRODUCT_TO_SHOPPING_BAG, newProducts)

            router.push({ name: 'ShoppingBag' })
          } else {
            actualProducts.push(productObject)
            commit(ADD_PRODUCT_TO_SHOPPING_BAG, actualProducts)

            router.push({ name: 'ShoppingBag' })
          }
        }
      } else {
        actualProducts.push(productObject)
        commit(ADD_PRODUCT_TO_SHOPPING_BAG, actualProducts)

        router.push({ name: 'ShoppingBag' })
      }
    } catch (error) {
      console.log(error)
      dispatch(
        'notification/pushNotification',
        {
          type: 'error',
          messages: [i18n.t('order.action.adding-pitem-cart-error')]
        },
        { root: true }
      )
    }
  },
  addBundleItemToShoppingBag({ commit, dispatch, state }, bundle) {
    let actualProducts = state.shoppingBagProducts

    // check if bundle is already in actualProducts
    if (actualProducts && actualProducts.length) {
      let bundleItem, isExistingBundle

      for (let i = 0; i < actualProducts.length; i++) {
        isExistingBundle = isEqual(actualProducts[i].items, bundle.items)
        if (isExistingBundle) {
          bundleItem = actualProducts[i]
          break
        }
      }
      console.log('bundleItem', bundleItem)
      if (isExistingBundle) {
        let bundleItems = bundleItem.items
        let isBundleQuantityValid = true

        // Where check for items in bundle validity should happen
        bundleItems.forEach(item => {
          if (bundleItem.quantity + 1 > item.inventoriesCount) {
            isBundleQuantityValid = false
          }
        })

        if (isBundleQuantityValid) {
          bundleItem.quantity += 1
        } else {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [i18n.t('order.action.max-items-cart')]
            },
            { root: true }
          )
        }
      } else {
        actualProducts.push(bundle)
      }

      commit(ADD_PRODUCT_TO_SHOPPING_BAG, actualProducts)
    } else {
      actualProducts.push(bundle)
      commit(ADD_PRODUCT_TO_SHOPPING_BAG, actualProducts)
    }

    router.push({ name: 'ShoppingBag' })
  },

  setSelectdRecipient(
    { commit },
    { recipientId, recipientResourceType, salesForceRecipient }
  ) {
    commit(SET_SELECTED_RECIPIENT, {
      recipientId,
      recipientResourceType,
      salesForceRecipient
    })
  },
  setSelectedTemplate({ commit }, selectedTemplateId) {
    commit(SET_SELECTED_TEMPLATE, selectedTemplateId)
  },
  async removeShoppingBagItem({ commit, state, dispatch }, product) {
    if (state.currentOrderId === null) {
      commit(REMOVE_PRODUCT_FROM_SHOPPING_BAG, product)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('order.action.item-removed-cart-success')]
        },
        { root: true }
      )
    } else {
      // Cause the items is already added to the order we need to use the team/orders/:orderId with quantity o to remove the item from the current order
      try {
        let currenOrderId = state.currentOrderId

        if (product.type === 'bundle') {
          product.items.forEach(item => {
            gemnoteAPI.post(`team/orders/${currenOrderId}/items`, {
              item: {
                product_variant_id: parseInt(item.id),
                quantity: 0,
                bundle_id: parseInt(product.bundle_id)
              }
            })
          })
        } else {
          let item = {
            item: {
              product_variant_id: parseInt(product.selectedVariant.id),
              quantity: 0,
              bundle_id: null
            }
          }

          await gemnoteAPI.post(`team/orders/${currenOrderId}/items`, item)
        }

        commit(REMOVE_PRODUCT_FROM_SHOPPING_BAG, product)
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('order.action.item-removed-cart-success')]
          },
          { root: true }
        )
      } catch (error) {
        console.log(error)
        let errors = []
        if (error.response) {
          if (error.response.status === 500 || error.response.status === 404) {
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: [
                  error.response.status === 500
                    ? i18n.t('server.server-error')
                    : i18n.t('server.not-found')
                ]
              },
              { root: true }
            )
          } else {
            let { errors } = error.response.data
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: [errors[0].message[0]]
              },
              { root: true }
            )
          }
        } else if (error.request) {
          errors.push(i18n.t('server.no-response'))
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        } else {
          errors.push(i18n.t('order.action.item-removed-cart-error'))
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      }
    }
  },
  increaseShoppingBagItem({ commit, state, dispatch }, product) {
    let productIndex = ''

    if (product.type === 'product') {
      productIndex = state.shoppingBagProducts.findIndex(
        prd =>
          prd.type == 'product' &&
          prd.selectedVariant.id == product.selectedVariant.id
      )
    }

    if (!product.type) {
      productIndex = state.shoppingBagProducts.findIndex(
        prd => !prd.type && prd.selectedVariant.id == product.selectedVariant.id
      )
    }

    if (productIndex > -1) {
      // Checks for cases of cards and normal products inventory count
      const inventoryCount =
        product.type == 'product'
          ? state.shoppingBagProducts[productIndex].selectedVariant
              .inventoriesCount
          : state.shoppingBagProducts[productIndex].selectedVariant
              .inventoriesCount[parseInt(product.selectedVariant.id)]

      if (state.shoppingBagProducts[productIndex].quantity < inventoryCount) {
        commit(INCREASE_ITEM_SHOPPING_BAG, productIndex)
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('order.action.max-quantity-reached')]
          },
          { root: true }
        )
      }
    }
  },
  increaseBundleItem({ commit, state, dispatch }, product) {
    let productIndex = product.index

    if (productIndex > -1) {
      // check if the inventoriesCount of any of the items in the bundle is less than the quantity of the bundle
      let bundleItems = state.shoppingBagProducts[productIndex].items
      let isBundleQuantityValid = true

      bundleItems.forEach(item => {
        if (product.quantity + 1 > item.inventoriesCount) {
          isBundleQuantityValid = false
        }
      })

      if (isBundleQuantityValid) {
        commit(INCREASE_ITEM_SHOPPING_BAG, productIndex)
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('order.action.bundle-max-items-cart', {
                0: product.selectedVariant
                  ? product.selectedVariant.displayName
                  : '',
                1: product.quantity
              })
            ]
          },
          { root: true }
        )
      }
    }
  },

  updateShoppingBagItemQty({ commit, state }, product) {
    let productIndex = ''

    if (product.type === 'bundle') {
      productIndex = productIndex = state.shoppingBagProducts.findIndex(
        prd => prd.type === 'bundle' && prd.bundle_id === product.bundle_id
      )
    }

    if (product.type === 'product') {
      productIndex = state.shoppingBagProducts.findIndex(
        prd =>
          prd.type == 'product' &&
          prd.selectedVariant.id == product.selectedVariant.id
      )
    }

    if (!product.type) {
      productIndex = state.shoppingBagProducts.findIndex(
        prd => !prd.type && prd.selectedVariant.id == product.selectedVariant.id
      )
    }

    if (productIndex > -1) {
      commit(UPDATE_ITEM_QTY_SHOPPING_BAG, {
        productIndex,
        quantity: product.quantity
      })
    }
  },

  decreaseShoppingBagItem({ commit, state }, product) {
    let productIndex = ''

    if (product.type == 'bundle') {
      productIndex = product.index
    }

    if (product.type == 'product') {
      productIndex = state.shoppingBagProducts.findIndex(
        prd =>
          prd.type == 'product' &&
          prd.selectedVariant.id == product.selectedVariant.id
      )
    }

    if (!product.type) {
      productIndex = state.shoppingBagProducts.findIndex(
        prd => !prd.type && prd.selectedVariant.id == product.selectedVariant.id
      )
    }
    if (productIndex > -1) {
      if (state.shoppingBagProducts[productIndex].quantity >= 2) {
        commit(DECREASE_ITEM_SHOPPING_BAG, productIndex)
      }
    }
  },
  async updateOrderCartItemQty({ state, dispatch }, { productId, action }) {
    const productIndex = state.shoppingBagProducts.findIndex(
      ({ selectedVariant }) => selectedVariant.id == productId
    )
    const product = { ...state.shoppingBagProducts[productIndex] }
    if (action === 'increase') {
      await dispatch('increaseShoppingBagItem', product)
    } else {
      await dispatch('decreaseShoppingBagItem', product)
    }
    if (product.quantity !== state.shoppingBagProducts[productIndex].quantity) {
      try {
        let item = {
          item: {
            product_variant_id: parseInt(product.selectedVariant.id),
            quantity: state.shoppingBagProducts[productIndex].quantity
          }
        }
        await gemnoteAPI.post(`team/orders/${state.currentOrderId}/items`, item)
        dispatch('getIndividualOrder', state.currentOrderId)
      } catch (error) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('order.action.error-updating-order')]
          },
          { root: true }
        )
      }
    }
  },

  async removeItemFromOrder({ state, dispatch }, productId) {
    const product = state.shoppingBagProducts.find(
      ({ selectedVariant }) => selectedVariant.id == productId
    )
    if (product.attributes && isCard(product.attributes.tagList)) {
      localStorage.removeItem('selectedCard')
    }
    await dispatch('removeShoppingBagItem', product)
    await dispatch('getIndividualOrder', state.currentOrderId)
  },
  setCardMessage({ commit }, cardMessage) {
    commit(SET_CARD_MESSAGE, cardMessage)
  },
  async payOrder({ commit, dispatch, state }, id) {
    try {
      commit(DISABLE_PAY_BUTTON, true)
      await dispatch('createOrder', {
        recipientId: parseInt(state.selectedRecipientId),
      })
      await gemnoteAPI.post(`/team/orders/${id}/charge_and_begin_processing`)

      commit(CLEAR_ORDER)
      commit(SET_SELECTED_SHIPPING_RATE, null)
      commit(SET_SHIPPING_RATE_ERROR, false)
      commit('recipient/CLEAR_RECIPIENT_OBJECT', null, { root: true })
      dispatch('recipient/resetRecipientState', {}, { root: true })
      commit(DISABLE_PAY_BUTTON, false)
      // dispatch user profile to update object and display current budget
      await dispatch(
        'profile/getProfile',
        { reloadProfile: false },
        { root: true }
      )

      // push to Confirmed Order page
      router.push({
        path: '/confirmed-order',
        query: { isConfirmed: true }
      })
    } catch (error) {
      console.log(error)
      commit(DISABLE_PAY_BUTTON, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('order.action.charge-and-processing-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async checkForLastUnpaidOrder({ commit, rootState, rootGetters }) {
    // deprecated since it was causing issues, we need to find a better aproach, maybe manually action fired by the user.
    try {
      let isTeamOwner = rootGetters['profile/isTeamOwner']
      let apiRoute = isTeamOwner
        ? 'team/orders'
        : `team/users/${rootState.profile.user.id}/orders`
      let response = await gemnoteAPI.get(apiRoute)
      let { data } = response.data
      if (data.length) {
        // filter only for unpaid orders
        let unpaidOrders = data.filter(
          order => order.attributes.state === 'unpaid'
        )

        // last week orders
        let actualDay = moment().format('MM/DD/YYYY')
        let days = process.env.VUE_APP_DAYS_CHECK_UNPAID_ORDER || 7

        let lastUnpaidOrder = null
        while (days >= 1) {
          lastUnpaidOrder = unpaidOrders.find(
            order =>
              moment(order.attributes.createdAt).format('MM/DD/YYYY') ===
              actualDay
          )
          if (lastUnpaidOrder) {
            break
          }
          days = days - 1
          actualDay = moment(actualDay)
            .subtract(1, 'days')
            .format('MM/DD/YYYY')
        }

        // if we found an unpaid order on the 3 days range then commit all required elements to repopulate the cart
        if (lastUnpaidOrder) {
          let { id } = lastUnpaidOrder
          response = await gemnoteAPI.get(`team/orders/${id}`)
          let [order, included] = [getData(response), getIncluded(response)]
          let recipientId = included.find(
            include => include.type === 'recipients'
          )
          recipientId = recipientId.id
          let recipientResourceType = 'gemnoteUID'

          let orderItems = included.filter(
            include => include.type === 'orderItems'
          )
          commit(SET_ORDER_ID, String(id))
          commit(
            SET_CARD_MESSAGE,
            order.attributes.cardMessage ? order.attributes.cardMessage : ''
          )
          commit(SET_SELECTED_RECIPIENT, {
            recipientId,
            recipientResourceType
          })

          let cartProducts = []
          orderItems.forEach(item => {
            let productVariant = {
              id: item.relationships.productVariant.data.id,
              name: item.attributes.name,
              displayName: item.attributes.productName,
              price: item.attributes.price,
              size: item.attributes.size ? item.attributes.size.name : '',
              color: item.attributes.color ? item.attributes.color.name : '',
              imageURL:
                item.attributes.representativeImages.length > 0
                  ? item.attributes.representativeImages[0].url
                  : null,
              inventoriesCount: 0
            }

            let product = {
              id: String(item.attributes.productId),
              selectedVariant: productVariant,
              quantity: parseInt(item.attributes.quantity)
            }

            cartProducts.push(product)
          })
          commit(ADD_PRODUCT_TO_SHOPPING_BAG, cartProducts)
        }
      }
    } catch (error) {
      console.log(error)
    }
  },
  setSalesforceResorceType({ commit }, salesForceResourceType) {
    commit(SET_SALESFORCE_RESOURCE_TYPE, salesForceResourceType)
  },
  setSalesforceRecordUID({ commit }, salesForceRecordUID) {
    commit(SET_SALESFORCE_RECORD_UID, salesForceRecordUID)
  },
  resetOrderState({ commit }) {
    commit(RESET_ORDER_STATE)
  },
  resetInventoryCheck({ commit }) {
    commit(SET_CHECK_INVENTORY_RESPONSE, [])
  },
  async addCardToCartToCart({ commit, state, dispatch }, productObject) {
    let cartProducts = state.shoppingBagProducts
    if (cartProducts) {
      let productInCart = cartProducts.find(
        product =>
          product &&
          product.selectedVariant &&
          product.selectedVariant.id === productObject.selectedVariant.id
      )
      if (!productInCart) {
        cartProducts.push(productObject)
        commit(ADD_PRODUCT_TO_SHOPPING_BAG, cartProducts)
        if (state.currentOrderId) {
          try {
            let item = {
              item: {
                product_variant_id: parseInt(productObject.selectedVariant.id),
                quantity: parseInt(productObject.quantity)
              }
            }
            await gemnoteAPI.post(
              `team/orders/${state.currentOrderId}/items`,
              item
            )
          } catch (e) {
            console.error(e)
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: [i18n.t('server.server-error')]
              },
              { root: true }
            )
          }
        }
      }
    }
  },

  async checkRushOrder({ commit, dispatch, state }, payload) {
    try {
      const items = buildCartFromBag(state.shoppingBagProducts)
      commit(SET_LOADING_SHIPPING_RATES, status.LOADING)
      let apiRoute = `team/shipping/rates`
      const response = await gemnoteAPI.post(apiRoute, {
        ...payload,
        selected_items_json: items
      })
      const selectedShippingRate = state.selectedShippingRate
      let updatedSelectedShippingRate = null

      const rates = response.data.rates
      const standardServiceName = 'standard'
      if (rates.length) {
        const standardRate = rates.find(rate =>
          rate.dataAttributes.service_name
            .toLowerCase()
            .includes(standardServiceName)
        )
        if (standardRate && !selectedShippingRate) {
          commit(SET_SELECTED_SHIPPING_RATE, standardRate)
        }
        if (selectedShippingRate) {
          updatedSelectedShippingRate = rates.find(
            rate =>
              rate.dataAttributes.service_name ===
              selectedShippingRate.dataAttributes.service_name
          )
        }

        if (updatedSelectedShippingRate) {
          commit(SET_SELECTED_SHIPPING_RATE, updatedSelectedShippingRate)
        }
      }

      commit(SET_SHIPPING_RATES, rates)

      commit(SET_LOADING_SHIPPING_RATES, status.LOADED)
      commit(SET_SHIPPING_RATE_ERROR, false)

      return response.data.rates
    } catch (error) {
      commit(SET_LOADING_SHIPPING_RATES, status.ERROR)
      commit(SET_SHIPPING_RATES, [])
      commit(SET_SELECTED_SHIPPING_RATE, null)
      commit(SET_SHIPPING_RATE_ERROR, true)
      // let errors = []
      // if (error.response) {
      //   if (error.response.status === 500 || error.response.status === 404) {
      //     dispatch(
      //       'notification/pushNotification',
      //       {
      //         type: 'error',
      //         messages: [
      //           error.response.status === 500
      //             ? i18n.t('server.server-error')
      //             : i18n.t('server.not-found')
      //         ]
      //       },
      //       { root: true }
      //     )
      //   } else {
      //     let { errors } = error.response.data
      //     let message = 'Unable to get shipping rates. Please try again.'
      //
      //     if (errors.length && errors[0].message.length) {
      //       message = errors[0].message
      //     }
      //
      //     dispatch(
      //       'notification/pushNotification',
      //       {
      //         type: 'warning',
      //         messages: [message]
      //       },
      //       { root: true }
      //     )
      //   }
      // } else if (error.resquest) {
      //   errors.push(i18n.t('server.no-response'))
      //   dispatch(
      //     'notification/pushNotification',
      //     {
      //       type: 'error',
      //       messages: errors
      //     },
      //     { root: true }
      //   )
      // } else {
      //   errors.push('Something went wrong')
      //   dispatch(
      //     'notification/pushNotification',
      //     {
      //       type: 'error',
      //       messages: errors
      //     },
      //     { root: true }
      //   )
      // }
    }
  },
  async addRateToOrder({ commit }, { orderId, rateId }) {
    try {
      await gemnoteAPI.post(`team/orders/${orderId}/shipping`, {
        rate_id: rateId
      })
      // commit(SET_SELECTED_SHIPPING_RATE, null)
    } catch (error) {
      console.error(error)
    }
  }
}
